import { render, staticRenderFns } from "./Trivia5.vue?vue&type=template&id=c6261ab4&scoped=true&"
import script from "./Trivia5.vue?vue&type=script&lang=js&"
export * from "./Trivia5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6261ab4",
  null
  
)

export default component.exports